import { render, staticRenderFns } from "./ContentDetails.vue?vue&type=template&id=77c03e16&scoped=true&"
import script from "./ContentDetails.vue?vue&type=script&lang=js&"
export * from "./ContentDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContentDetails.vue?vue&type=style&index=0&id=77c03e16&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c03e16",
  null
  
)

export default component.exports